import { Table } from "@/features/Table";
import { type Workbook, workbooks_columns } from "./columns";
import { type FilterWorkbookSchema, FilterWorkbook } from "./filter";
import { useLocation } from "react-router-dom";

const client = "tableau-quantilia";
const table_name = "workbooks";

export const WorkbooksTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Workbook, FilterWorkbookSchema>
      label="Workbooks"
      client={client}
      table_name={table_name}
      columns={workbooks_columns}
      filter={<FilterWorkbook />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
